<div class="row col-xl-12 mb-4">
	<div class="col-xl-4 col-md-4">
		<label for="workingDaysSelect">{{"operation_analysis.working_days" | translate}}</label>
		<ng-select
			class="select"
			[items]="daysFilters"
			[addTag]="false"
			[clearable]="false"
			[searchable]="false"
			bindLabel="label"
			bindValue="value"
			(change)="onSelectionChanged({filter: 'daysFilter', value: $event.value})"
			[placeholder]="'g.durations' | translate"
			[(ngModel)]="selectedDaysFilter"
		></ng-select>
	</div>
</div>

<app-truck-fleet-usage-summary [data]="data" [showLegend]="true" [showFooterDate]="false" [forAnalytics]="false" [selectedDays]="selectedDaysFilter"></app-truck-fleet-usage-summary>
